/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

FooterService.$inject = [
    'AnalyticsService',
    'NavLinksService'
];
function FooterService (
    AnalyticsService,
    NavLinksService
) {
    return {
        getFooterLinks: getFooterLinks,
        trackNavEngagement: trackNavEngagement
    };

    /**
     * Gets footer links from NavLinksService
     * @returns {$q.promise}
     */
    function getFooterLinks () {
        return NavLinksService.getFooterLinks();
    }

    /**
     * Tracks any engagement that happens with the footer.
     * @param display
     * @param url
     */
    function trackNavEngagement (display, url) {
        return AnalyticsService.reportEvent('Nav Engaged', {
            location: 'footer',
            url: url,
            value: display
        });
    }
}

module.exports = FooterService;